import { Component, Input, SimpleChanges } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { HazardCode } from '../../../../../../../shared/Container/model/HazardCode';
import { FreightPayer } from '../../../../../../../shared/freight-payers/models/FreightPayer';
import { ContainerService } from '../../../../../../../shared/Container/container.service';
import { CommonModule } from '@angular/common';
import { NgSelectComponent } from '@ng-select/ng-select';
import { CustomDateRangePickerComponent } from '../../../../../../../shared/components/custom-date-range-picker/custom-date-range-picker.component';

@Component({
  selector: 'app-container-additional-properties',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgSelectComponent, CustomDateRangePickerComponent],
  templateUrl: './container-additional-properties.component.html',
  styleUrl: './container-additional-properties.component.scss'
})
export class ContainerAdditionalPropertiesComponent {
  @Input()
  formGroup!: FormGroup;

  @Input()
  freightPayer!: FreightPayer;

  // Lookups
  availableHazardCodes: HazardCode[] = [];

  constructor(private containerService: ContainerService) { }

  ngOnInit() {

    this.containerService.getHazardCodes()
      .subscribe(codes => {
        this.availableHazardCodes = codes;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formGroup']) {
      this.formGroup.patchValue(changes['formGroup'], { emitEvent: false });
    }
  }

  getHazmatCodeIsRequired = () => this.formGroup && this.formGroup.value.isHazmat;
}
